<template>
  <v-app class="red-2">

   <router-view></router-view>
  
  </v-app>
</template>

<script>

  import { mapMutations } from 'vuex';
export default {
  name: 'App',
  created: function () {
    // `this` points to the vm instance
    this.setUrl(this.GLOBAL_CONFIG.apiURL);
  
  },
  props: [ "template"],

  methods:{
   ...mapMutations([
        "setUrl"
      ])
  },
  data: () => ({
    //
  }),
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400;740&display=swap');

h1{
  color:#444;
  font-family: 'Maven Pro', sans-serif;
}
body{
  font-family:Verdana, Geneva, Tahoma, sans-serif;
}
.v-main{
  background-color:#EFEFEF;
}
</style>
